import React from 'react'
import ReactDOM from 'react-dom'

import App from './app'
import './style.css'



ReactDOM.render(<App />, document.getElementById("root"))

